// Control del intro animado con localStorage (1 vez por semana)
document.addEventListener('DOMContentLoaded', function() {
    const preloader = document.getElementById('page-preloader');
    const hero = document.getElementById('hero');

    // Si no hay preloader ni hero, no hacer nada (no estamos en front-page)
    if (!preloader || !hero) {
        if (hero) hero.classList.add('hero-visible');
        return;
    }

    const now = new Date();
    const lastShown = localStorage.getItem('sbs_intro_date');

    if (lastShown) {
        const daysSince = (now - new Date(lastShown)) / (1000 * 60 * 60 * 24);
        if (daysSince < 7) {
            preloader.style.display = 'none';
            showHero(true);
            return;
        }
    }

    localStorage.setItem('sbs_intro_date', now.toISOString());
    const today = now.toISOString().slice(0, 10);

    // Mostrar hero después del intro
    setTimeout(() => {
        preloader.classList.add('loaded');

        setTimeout(() => {
            preloader.style.display = 'none';
            showHero();
        }, 600);
    }, 3500);

    function showHero(instant) {
        // Mostrar hero
        hero.classList.add('hero-visible');

        // Iniciar animaciones del hero
        const elements = document.querySelectorAll('.hero-line, .hero-separator, .hero-subtitle');

        elements.forEach(el => {
            if (instant) {
                el.classList.add('animated');
                return;
            }

            const delay = parseInt(el.getAttribute('data-delay')) || 0;

            setTimeout(() => {
                el.classList.add('animated');
            }, delay);
        });

        // Animar SVG flotantes
        if (instant) {
            document.querySelectorAll('.floating-svg').forEach(svg => svg.classList.add('active'));
            return;
        }

        setTimeout(() => {
            document.querySelectorAll('.floating-svg').forEach((svg, i) => {
                setTimeout(() => {
                    svg.classList.add('active');
                }, i * 300);
            });
        }, 500);
    }

    // Skip intro si el usuario presiona ESC o hace clic
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && preloader && !preloader.classList.contains('loaded')) {
            skipIntro();
        }
    });

    preloader.addEventListener('click', function(e) {
        if (!e.target.closest('.intro-glass')) {
            skipIntro();
        }
    });

    function skipIntro() {
        localStorage.setItem('sbs_intro_date', today);
        preloader.classList.add('loaded');
        setTimeout(() => {
            preloader.style.display = 'none';
            showHero();
        }, 300);
    }
});

// Efecto de nav al hacer scroll - en todo el sitio
document.addEventListener('DOMContentLoaded', function() {
    const mainNav = document.getElementById('main-nav');
    const wrapperNavbar = document.getElementById('wrapper-navbar');
    
    // Aplicar en todo el sitio si existe el nav
    if (mainNav && wrapperNavbar) {
        
        function handleScroll() {
            const scrollPosition = window.scrollY;
            
            // Agregar clase scrolled cuando se hace scroll
            if (scrollPosition > 50) {
                mainNav.classList.add('scrolled');
            } else {
                mainNav.classList.remove('scrolled');
            }
        }
        
        // Escuchar el evento scroll
        window.addEventListener('scroll', handleScroll);
        
        // Ejecutar una vez al cargar
        handleScroll();
        
        // Asegurar que el navbar sea fijo en todas las páginas
        wrapperNavbar.style.position = 'fixed';
        wrapperNavbar.style.top = '0';
        wrapperNavbar.style.left = '0';
        wrapperNavbar.style.width = '100%';
        wrapperNavbar.style.zIndex = '9999';
    }
});

// Acordeón inline para los dropdowns del menú offcanvas — solo mobile (<768px)
// En desktop el dropdown sigue funcionando con el comportamiento nativo de Bootstrap
document.addEventListener('DOMContentLoaded', function() {
    const offcanvasNav = document.querySelector('#navbarNavOffcanvas .navbar-nav');

    if (!offcanvasNav) {
        return;
    }

    offcanvasNav.querySelectorAll('.dropdown > .dropdown-toggle').forEach(function(toggle) {
        toggle.addEventListener('click', function(event) {
            if (window.innerWidth >= 768) {
                return; // Desktop: dejar el dropdown nativo de Bootstrap sin tocar
            }

            event.preventDefault();
            event.stopPropagation();

            const parentItem = toggle.closest('.dropdown');
            const isOpen = parentItem.classList.toggle('dropdown-open');
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    });
});

// Ajuste para admin bar de WordPress
(function() {
    const adjustNavbarForAdminBar = function() {
        const wrapperNavbar = document.getElementById('wrapper-navbar');
        const adminBar = document.getElementById('wpadminbar');
        
        if (wrapperNavbar && adminBar) {
            const adminBarHeight = adminBar.offsetHeight;
            wrapperNavbar.style.top = adminBarHeight + 'px';
        }
    };
    
    // Ejecutar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', adjustNavbarForAdminBar);
    } else {
        adjustNavbarForAdminBar();
    }
    
    // Reajustar si la admin bar cambia (raro, pero por si acaso)
    window.addEventListener('resize', adjustNavbarForAdminBar);
})();

// ============================================================================
// ACCESSIBILITY: Modal Focus Trap for Event Modals
// ============================================================================
(function() {
    // Get all event modals
    const eventModals = document.querySelectorAll('.event-modal');

    eventModals.forEach(modal => {
        // When modal is shown
        modal.addEventListener('shown.bs.modal', function() {
            // Forzar z-index alto para que el modal aparezca encima del navbar
            const modalElement = document.querySelector('.modal.event-modal.show');
            const backdrop = document.querySelector('.modal-backdrop.show');
            
            if (modalElement) {
                modalElement.style.zIndex = '100000';
            }
            
            if (backdrop) {
                backdrop.style.zIndex = '99999';
            }

            // Get all focusable elements within the modal
            const focusableElements = modal.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );

            const firstFocusable = focusableElements[0];
            const lastFocusable = focusableElements[focusableElements.length - 1];

            // Focus the first focusable element (usually the close button)
            if (firstFocusable) {
                firstFocusable.focus();
            }

            // Trap focus within modal
            const trapFocus = function(e) {
                const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                if (!isTabPressed) {
                    return;
                }

                // If Shift + Tab
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusable) {
                        e.preventDefault();
                        lastFocusable.focus();
                    }
                } else {
                    // If Tab only
                    if (document.activeElement === lastFocusable) {
                        e.preventDefault();
                        firstFocusable.focus();
                    }
                }
            };

            // Store the trap function on the modal for later removal
            modal._trapFocusHandler = trapFocus;
            modal.addEventListener('keydown', trapFocus);

            // Announce modal opening to screen readers
            const modalTitle = modal.querySelector('.event-modal__title');
            if (modalTitle) {
                const announcement = document.createElement('div');
                announcement.setAttribute('role', 'status');
                announcement.setAttribute('aria-live', 'polite');
                announcement.className = 'sr-only';
                announcement.textContent = 'Event details opened: ' + modalTitle.textContent;
                document.body.appendChild(announcement);
                setTimeout(() => announcement.remove(), 1000);
            }
        });

        // When modal is hidden
        modal.addEventListener('hidden.bs.modal', function() {
            // Remove focus trap
            if (modal._trapFocusHandler) {
                modal.removeEventListener('keydown', modal._trapFocusHandler);
                modal._trapFocusHandler = null;
            }
        });
    });
})();